import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../utils/api';

const Logout = () => {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    // Clear all auth state via api.logout() (clears token + user keys from localStorage)
    api.logout();
    // Brief pause for UX then redirect
    await new Promise((resolve) => setTimeout(resolve, 800));
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-[#050d1f] text-white flex flex-col items-center justify-center p-8 relative overflow-hidden font-sans">

      {/* Background Glows */}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-[#4d7cff]/10 rounded-full blur-[120px]" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[30%] h-[30%] bg-[#4d7cff]/5 rounded-full blur-[100px]" />

      {/* Logo */}
      <div className="absolute top-8 left-8 z-10">
        <h1 className="text-2xl font-bold text-[#4d7cff] tracking-tight">PlayerIQ</h1>
      </div>

      {/* Card */}
      <div className="relative z-10 w-full max-w-md">
        <div className="absolute -inset-0.5 bg-[#4d7cff]/20 rounded-[32px] blur-sm" />

        <div className="relative bg-[#0c1526]/95 backdrop-blur-2xl border border-white/[0.08] rounded-[32px] p-8 sm:p-12 flex flex-col items-center text-center">

          {/* Icon */}
          <div className="w-16 h-16 rounded-full bg-[#4d7cff]/10 border border-[#4d7cff]/20 flex items-center justify-center mb-6">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#4d7cff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </div>

          <h2 className="text-2xl font-bold mb-2">Log Out?</h2>
          <p className="text-white/40 text-sm leading-relaxed mb-10">
            You'll need to sign back in to access your predictions, favorites, and league data.
          </p>

          <div className="flex flex-col gap-3 w-full">
            <button
              onClick={handleLogout}
              disabled={isLoggingOut}
              className="w-full bg-[#4d7cff] hover:bg-[#3d6cef] disabled:opacity-60 text-white font-bold py-4 rounded-2xl transition-all shadow-[0_10px_20px_rgba(77,124,255,0.2)] flex items-center justify-center gap-2"
            >
              {isLoggingOut ? (
                <>
                  <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                  </svg>
                  Logging out...
                </>
              ) : 'Yes, Log Out'}
            </button>
            <button
              onClick={() => navigate(-1)}
              disabled={isLoggingOut}
              className="w-full bg-white/5 hover:bg-white/10 text-white/60 hover:text-white font-bold py-4 rounded-2xl transition-all"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logout;